export function validateSecurityNumber(value: string | undefined): boolean {
  const cleanedValue = value ? value.trim().replaceAll(" ", "").replaceAll("_", "") : "";

  if (cleanedValue == "") { return true; }

  const regex = /^\d{11}$/;

  return !!cleanedValue.match(regex);
}
